'use strict';

(function () {
      document.addEventListener('DOMContentLoaded', () => {
            const spMenuButton = document.querySelector('.fes-building-btn');
            spMenuButton.addEventListener('click', () => {
                  // メニューのトグル処理（spMenuButtonにis-openクラスを付与）
                  spMenuButton.classList.toggle('is-open');
            });
      });
})();